import React from 'react'

/**
 * Full screen backdrop image
 */
class Backdrop extends React.Component {
  static propTypes = {
    url: React.PropTypes.string,
    children: React.PropTypes.node
  }

  render() {
    const { url, children } = this.props
    if (!url) return <div>{children}</div>

    const style = {
      backgroundImage: `
        linear-gradient(to bottom, rgba(255,255,255,0) 0%, #fff 25%, #fff),
        url(${url})
      `
    }

    return (
      <div>
        <div className="redi-component-backdrop" style={style} />
        {children}
      </div>
    )
  }
}

export default Backdrop



// WEBPACK FOOTER //
// ./modules/shared/components/backdrop.js